module.exports = __webpack_public_path__ + "static/img/Ellipse 99.49ee6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 99.png
// module id = CT37
// module chunks = 1